import { Link } from "react-router-dom";
import { Instagram, Facebook } from "lucide-react";

const TikTokIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M9 12a4 4 0 1 0 4 4V4a5 5 0 0 0 5 5" />
  </svg>
);

const Footer = () => (
  <footer data-testid="site-footer" className="bg-ink text-ivory">
    <div className="mx-auto max-w-7xl px-6 sm:px-12 lg:px-20 py-16 md:py-24">
      <div className="grid gap-14 md:grid-cols-12">
        <div className="md:col-span-5">
          <div className="inline-block bg-ivory px-6 py-4">
            <img src="/assets/logo.png" alt="Merari Candle Company" className="h-12 w-auto object-contain" data-testid="footer-logo" />
          </div>
          <p className="mt-8 max-w-sm font-serif text-xl font-light leading-relaxed text-ivory/80 italic">
            Beautifully Scented. Hand-Poured. Made With Intention.
          </p>
          <div className="mt-8 flex gap-3">
            <a data-testid="footer-instagram" href="https://instagram.com/meraricandleco" target="_blank" rel="noreferrer" aria-label="Instagram" className="flex h-10 w-10 items-center justify-center border border-white/20 transition-colors duration-300 hover:bg-ivory hover:text-ink"><Instagram size={16} strokeWidth={1.5} /></a>
            <a data-testid="footer-facebook" href="https://facebook.com" target="_blank" rel="noreferrer" aria-label="Facebook" className="flex h-10 w-10 items-center justify-center border border-white/20 transition-colors duration-300 hover:bg-ivory hover:text-ink"><Facebook size={16} strokeWidth={1.5} /></a>
            <a data-testid="footer-tiktok" href="https://tiktok.com" target="_blank" rel="noreferrer" aria-label="TikTok" className="flex h-10 w-10 items-center justify-center border border-white/20 transition-colors duration-300 hover:bg-ivory hover:text-ink"><TikTokIcon /></a>
          </div>
        </div>
        <div className="md:col-span-3">
          <h4 className="font-mono text-[10px] uppercase tracking-[0.35em] text-ivory/50">Explore</h4>
          <ul className="mt-6 space-y-3 text-sm text-ivory/80">
            {[["Shop", "/shop"], ["Create Your Scent", "/create-your-scent"], ["Candle Experience", "/experience"], ["Custom Favors", "/favors"], ["About", "/about"], ["Contact", "/contact"]].map(([label, to]) => (
              <li key={to}><Link data-testid={`footer-link-${label.toLowerCase().replace(/\s+/g, "-")}`} to={to} className="transition-colors duration-300 hover:text-ivory hover:underline underline-offset-4">{label}</Link></li>
            ))}
          </ul>
        </div>
        <div className="md:col-span-4">
          <h4 className="font-mono text-[10px] uppercase tracking-[0.35em] text-ivory/50">Support</h4>
          <ul className="mt-6 space-y-3 text-sm text-ivory/80">
            {[["FAQ", "faq"], ["Shipping Policy", "shipping"], ["Return Policy", "returns"], ["Privacy Policy", "privacy"], ["Terms & Conditions", "terms"]].map(([label, slug]) => (
              <li key={slug}><Link data-testid={`footer-link-${slug}`} to={`/policies/${slug}`} className="transition-colors duration-300 hover:text-ivory hover:underline underline-offset-4">{label}</Link></li>
            ))}
          </ul>
          <p className="mt-10 font-mono text-[10px] uppercase tracking-[0.3em] text-ivory/40">100% Soy Wax · Hand-Poured in Manayunk</p>
        </div>
      </div>
      <div className="mt-16 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 border-t border-white/10 pt-8">
        <p className="text-xs text-ivory/50">© {new Date().getFullYear()} Merari Candle Company. All rights reserved.</p>
        <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-ivory/40">Made with intention</p>
      </div>
    </div>
  </footer>
);

export default Footer;
